import { LoadingState } from 'src/app/utilities/state.util';
import { FullUserWithZoneParentFragment } from 'src/generated/graphql.generated';

export interface UserPageSimilarCustomersSourceUser {
    id: string;
    roleIds: string[];
    roles?: FullUserWithZoneParentFragment['roles'];
    zones?: FullUserWithZoneParentFragment['zones'];
    givenName?: string | null;
    familyName?: string | null;
    email?: string | null;
    phone?: string | null;
    company?: string | null;
    billingAddress?: {
        id: string;
        addressLineOne?: string | null;
        addressLineTwo?: string | null;
    } | null;
    metadata?: { niceJobsId?: string } | null;
}

export const userPageSimilarCustomersInitialState = {
    sourceUser: undefined as UserPageSimilarCustomersSourceUser | undefined,
    search: '' as string,
    customers: [] as FullUserWithZoneParentFragment[],
    loading: LoadingState.INIT as LoadingState,
};

export type UserPageSimilarCustomersState = typeof userPageSimilarCustomersInitialState;
